import projection from '../generated/pwc504f1.json';
import { AcceptanceManifest } from '../types';

export const pwc504f1AcceptanceManifest = projection as AcceptanceManifest;
